import { Link } from "react-router-dom";
import { useQuote } from "@/lib/quote";

export default function MobileQuoteBar() {
  const { count, setDrawerOpen } = useQuote();
  if (count === 0) return null;
  return (
    <button
      data-testid="mobile-quote-bar"
      onClick={() => setDrawerOpen(true)}
      className="fixed inset-x-0 bottom-0 z-40 flex items-center justify-between border-t border-ink/10 bg-ivory/95 px-5 py-3.5 backdrop-blur-xl lg:hidden"
      style={{ paddingBottom: "max(0.875rem, env(safe-area-inset-bottom))" }}
      aria-label={`View your quote list, ${count} items`}
    >
      <span className="font-display text-xl text-ink">My Quote</span>
      <span className="rounded-none bg-olive px-5 py-2 text-[12px] uppercase tracking-[0.16em] text-ivory">
        {count} item{count > 1 ? "s" : ""} — view
      </span>
    </button>
  );
}

export function MobileQuoteSpacer() {
  const { count } = useQuote();
  if (count === 0) return null;
  return <div className="h-16 lg:hidden" aria-hidden="true" />;
}

export function QuoteBarHelpLink() {
  const { count } = useQuote();
  if (count === 0) return null;
  return (
    <Link to="/quote" className="lg:hidden">
      Review quote ({count})
    </Link>
  );
}
